export enum SidebarAction {
  Toggle,
  Close,
  Open
}

export type ContentType = 'docs' | 'api';

export type APIType = 'core' | 'ally';